import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Check from "../views/Check.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "在线起名"
    }
  },
  {
    path: "/check",
    name: "check",
    component: Check,
    meta: {
      title: "在线核名"
    }
  },
  {
    path: "/heming",
    name: "Heming",
    component: Check,
    meta: {
      title: "在线核名"
    }
  },
  {
    path: "/class",
    name: "class",
    component: (resolve) => require(['@/views/Class'], resolve),
    meta: {
      title: "注册会计试听课",
      showHeader:false
    },
  },
  {
    path: "/account",
    name: "class",
    component: (resolve) => require(['@/views/Class2'], resolve),
    meta: {
      title: "中级会计试听课",
      showHeader:false
    }
  },
  {
    path: "/economist",
    name: "class",
    component: (resolve) => require(['@/views/Class3'], resolve),
    meta: {
      title: "中级经济师试听课",
      showHeader:false
    }
  },
  {
    path: "/tax",
    name: "class",
    component: (resolve) => require(['@/views/Class4'], resolve),
    meta: {
      title: "税务师试听课",
      showHeader:false
    }
  }
  
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

export default router;
